import { useMemo } from "react";
import { useShopContext } from "../../../context/shop/shop-context";
import type { ShopSelectionContextValue } from "./ShopSelection.types";

export const useShopSelection = (): ShopSelectionContextValue => {
  const { shops, shop, requestShopChange, refetchShops } = useShopContext();
  const value = useMemo(
    () => ({
      state: {
        shops: shops.map(({ id, shopId, name }) => ({ mongoShopId: id, shopId, name })),
        selectedShop: { mongoShopId: shop.id, shopId: shop.shopId, name: shop.name },
        loading: false
      },
      actions: { requestShopChange, refetchShops }
    }),
    [shops, shop, requestShopChange, refetchShops]
  );

  return value;
};
